const carListGridConfig = {
    columns: [
        {
            id: 1,
            width: 300,
            selector: 'registrationNumber',
            name: 'Регистрационен номер',
            sequenceNumber: 1,
            type: 'string'
        },
        {
            id: 2,
            width: 250,
            selector: 'brand',
            name: 'Марка',
            sequenceNumber: 2,
            type: 'string'
        },
        {
            id: 3,
            width: 250,
            selector: 'model',
            name: 'Модел',
            sequenceNumber: 3,
            type: 'string'
        },
        {
            id: 4,
            width: 250,
            selector: 'statusName',
            name: 'Статус',
            sequenceNumber: 4,
            type: 'string',
            filterComponent: 'CarStatusDropdown'
        },
        {
            id: 5,
            width: 250,
            selector: 'typeName',
            name: 'Тип',
            sequenceNumber: 5,
            type: 'string',
            filterComponent: 'CarTypeDropdown'
        },
        {
            id: 6,
            width: 250,
            selector: 'categoryName',
            name: 'Категория',
            sequenceNumber: 6,
            type: 'string',
            filterComponent: 'CarCategoryDropdown'
        }
    ],
    props: {
        headerRowHeight: 50,
        rowHeight: 52,
        tableHeight: 600,
        filterable: true,
        selectableColumn: {
            show: true,
            icon: 'fas fa-car-side',
            width: 90
        }
    }
};

export default carListGridConfig;